var _path;

import * as React from "react";

function SvgCrosshair(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16c0-.831.669-1.5 1.5-1.5s1.5.669 1.5 1.5-.669 1.5-1.5 1.5-1.5-.669-1.5-1.5zM16 0c.55 0 1 .448 1 1v2.038c6.381.485 11.475 5.58 11.962 11.962H31c.55 0 1 .45 1 1s-.45 1-1 1h-2.038c-.487 6.381-5.58 11.475-11.962 11.962V31c0 .55-.45 1-1 1s-1-.45-1-1v-2.038C8.619 28.476 3.523 23.383 3.038 17H1c-.552 0-1-.45-1-1s.448-1 1-1h2.038C3.523 8.619 8.618 3.523 15 3.038V1c0-.552.45-1 1-1zm-1 26.956V24c0-.55.45-1 1-1s1 .45 1 1v2.956c5.275-.475 9.481-4.681 9.956-9.956H24c-.55 0-1-.45-1-1s.45-1 1-1h2.956C26.481 9.725 22.275 5.52 17 5.045V8c0 .55-.45 1-1 1s-1-.45-1-1V5.045C9.725 5.521 5.52 9.725 5.045 15H8c.55 0 1 .45 1 1s-.45 1-1 1H5.045c.476 5.275 4.68 9.481 9.955 9.956z"
  })));
}

export default SvgCrosshair;